import { Component, ElementRef, EventEmitter, input, Input, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NavbarItem } from "src/app/interfaces/navbar-item.interface";
import { AuthenticationService } from "src/app/authentications/authentication.service";

@Component({
  selector: 'fspro-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: false
})
export class NavbarComponent {

  @ViewChild('rhMenuContainer') rhMenuContainer: ElementRef;
  @ViewChild('menuContainer') menuContainer: ElementRef;

  @Input() isToggled: boolean;
  public isUserRH = input(false);
  public isRestrictedToSinglePage = input(false);

  @Output() isToggledChange = new EventEmitter<boolean>();

  public readonly items: NavbarItem[] = [
    {
      title: 'fspro.front.header.nav.label.festivals',
      route: '/festivals',
      name: 'festival',
      activates: ['/festival/show/:slug']
    }, {
      title: 'fspro.front.header.nav.label.co_production_markets',
      route: '/co-production-markets',
      name: 'co-production-markets',
      activates: ['/coproduction/show/:slug']
    },
    {
      title: 'fspro.front.header.nav.label.labels',
      route: '/labels',
      name: 'labels',
      activates: ['/label/show/:slug']
    },
    {
      title: 'fspro.front.header.nav.label.line_ups',
      route: '/line-ups',
      name: 'lineups',
      activates: ['/line-up/show/:slug'],
    },
    {
      title: 'fspro.front.header.nav.label.films',
      route: '/films',
      name: 'film',
      activates: ['/film/:slug']
    },
    {
      title: 'fspro.front.header.nav.label.directors',
      route: '/directors',
      name: 'directors',
      activates: ['/director/:slug']
    },
    {
      title: 'fspro.front.header.nav.label.scope_expanded',
      route: '/scope-expanded/show',
      activates: ['/scope-expanded/show/:slug'],
      name: 'scope-expanded'
    }
  ];

  public rhMenuDisplayed: boolean = false;

  get user() {
    return this.authenticationService.user;
  }

  constructor(
    private readonly router: Router,
    private authenticationService: AuthenticationService,
  ) {}

  private isActive(route: string): boolean {
    const routeWithoutParameters = route.replace(/\/:[^/]+/g, '');

    return this.router.isActive(routeWithoutParameters, {
      paths: 'subset',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }

  public isItemActive(item: NavbarItem): boolean {
    return this.isActive(item.route) || (item.activates || []).some(route => this.isActive(route));
  }

  toggle(): void {
    console.log('toggle trigger')
    this.isToggled = !this.isToggled;
    this.isToggledChange.emit(this.isToggled);
  }

  open(): void {
    this.isToggled = true;
    this.isToggledChange.emit(true);
  }

  dismiss(): void {
    const elRhMenu = this.rhMenuContainer?.nativeElement as HTMLElement;
    elRhMenu.classList.remove('visible');
    elRhMenu.classList.add('hidden-mobile');

    const elMenu = this.menuContainer?.nativeElement as HTMLElement;
    elMenu.classList.remove('visible');
    elMenu.classList.remove('hidden-mobile');

    this.isToggled = false;
    this.rhMenuDisplayed = false;
    this.isToggledChange.emit(false);
  }

  public toggleRhMenu() {
    const elRhMenu = this.rhMenuContainer?.nativeElement as HTMLElement;
    const displayRhMenu = getComputedStyle(elRhMenu).display;

    const elMenu = this.menuContainer?.nativeElement as HTMLElement;
    const displayMenu = getComputedStyle(elMenu).display;

    if (displayRhMenu == 'none') {
      elRhMenu.classList.remove('hidden-mobile');
      elRhMenu.classList.add('visible');
      this.rhMenuDisplayed = true;

    } else {
      elRhMenu.classList.remove('visible');
      elRhMenu.classList.add('hidden-mobile');
      this.rhMenuDisplayed = false;
    }

    if (displayMenu == 'none') {
      elMenu.classList.remove('hidden-mobile');
      elMenu.classList.add('visible');
    } else {
      elMenu.classList.remove('visible');
      elMenu.classList.add('hidden-mobile');
    }
  }
}
